import React from 'react';
import FieldGroup from "./FieldGroup";

const Field = ({ value, name, label, onChange, required, error, className }) => {
    const hasError = !!error;

    const wrapperClass =
        'relative floating-label' +
        (hasError ? ' error' : '') +
        (className ? ' ' + className : '');

    const inputClass =
        'w-full bg-transparent border-b text-white py-3 focus:outline-none focus:ring-0 ' +
        (hasError
            ? 'border-red-500 focus:border-red-500'
            : 'border-neutrals-700 focus:border-neutrals-400');

    const labelClass =
        'text-neutrals-400' + (hasError ? ' text-red-500' : '');

    return (
        <div className={wrapperClass}>
            <input
                onChange={onChange}
                value={value ?? ''}
                name={name}
                type="text"
                required={!!required}
                aria-invalid={hasError}
                placeholder=" "
                className={inputClass}
            />
            <label className={labelClass}>{label}</label>
        </div>
    );
};

export default Field;
